import { type GetterTree } from 'vuex'

import { type OAuthState, type StripeState } from './model'

export const getters: GetterTree<OAuthState, unknown> = {
  stripe: (state: OAuthState): StripeState | null => {
    return state.stripe || null
  },
}
